import React from 'react'

function AccessTokenRedirect() {
  return (
    <div>AccessTokenRedirect</div>
  )
}

export default AccessTokenRedirect